import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const AmazonRDSReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="amazonRDSReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="amazonRDSReaderFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>

        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>

      <FormField
        controlId="amazonRDSReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormDatabaseType"
        label="databaseType"
        name="properties.databaseType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.databaseType?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormDatabaseName"
        label="databaseName"
        name="properties.databaseName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter database name"
        required
        error={errors.properties?.databaseName?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormDriver"
        label="driver"
        name="properties.driver"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter driver"
        required
        error={errors.properties?.driver?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormSqlQuery"
        label="sqlQuery"
        name="properties.sqlQuery"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter SQL query"
        required
        error={errors.properties?.sqlQuery?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormHost"
        label="host"
        name="properties.host"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter host"
        required
        error={errors.properties?.host?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormPort"
        label="port"
        name="properties.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        type="number"
        error={errors.properties?.port?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormInstanceConnectionName"
        label="instanceConnectionName"
        name="properties.instanceConnectionName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.properties?.instanceConnectionName?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormUsername"
        label="username"
        name="properties.username"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter username"
        error={errors?.properties?.username?.message}
      />

      <FormField
        controlId="amazonRDSReaderFormPassword"
        label="password"
        name="properties.password"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter password"
        error={errors?.properties?.password?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default AmazonRDSReaderForm;
